import { render } from "./ImageParams.vue?vue&type=template&id=7906495c"
import script from "./ImageParams.vue?vue&type=script&lang=js"
export * from "./ImageParams.vue?vue&type=script&lang=js"

import "./ImageParams.vue?vue&type=style&index=0&id=7906495c&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__